import { consumeContext } from "@/lib/consume/context"
import { NoticesContainer } from "@/lib/notices/container"
import { NoticesContext } from "@/lib/notices/context"

export namespace Notices {
  export type ContextData = {
    clearNotices: Functions.Clear
    displayNotice: Functions.Display
    list: Item[]
    removeNotice: Functions.Remove
  }

  export type ContextFunction =
    | `clearNotices`
    | `displayNotice`
    | `removeNotice`

  export type ContextFunctions = Pick<ContextData, ContextFunction>

  export type Collection = Record<ItemId, Item>

  export type ItemId = string

  export type Item = {
    id: ItemId
    message: string
    persistence: NoticePersistence
    type: Type
  }

  export type ItemOptions = {
    id: Item[`id`]
    message: Item[`message`]
    persistence?: Partial<NoticePersistence>
    type: Item[`type`]
  }

  export type NoticePersistence = {
    accruedRouteChanges: number
    maxRouteChanges: number
    untilDismissed: boolean
  }

  export type Type = `error` | `info` | `success` | `warning`

  export const Context = NoticesContext
  export const Container = NoticesContainer

  export const consume = consumeContext({
    Context: NoticesContext,
    provideTo: `notices`,
  })

  export const consumeFunctions = consumeContext({
    Context: NoticesContext,
    provideTo: `noticeFunctions`,
    takeOnly: [`clearNotices`, `displayNotice`, `removeNotice`],
  })

  export namespace Functions {
    export type BuildNotice = (args: ItemOptions) => Item

    export type Clear = () => void

    export type Display = (args: ItemOptions) => void

    export type Remove = (args: { id: ItemId }) => void
  }
}
